import React , {useDebugValue, useEffect, useState} from 'react';
import BarcodeScanner from 'react-qr-barcode-scanner';
import { AreaTitle } from './appBar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera, faFaceFrown, faFaceSmile } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Label } from '@progress/kendo-react-labels';
import { Input } from '@progress/kendo-react-inputs';
import { Dialog, DialogActionsBar} from '@progress/kendo-react-dialogs';

const SpeakerList=({setChoice})=>{
    const [speakers,setSpeakers]=useState();

    const [select,setSelect]=useState("");

    const getSpeakers = async ()=>{
        const url= "api/index.php/program/getSpeakerList";
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            setSpeakers(data);
        })
    }

    const selectionChange=(event)=>{
        console.log(event.value);
        const areaID=event.value["AreaID"];
        console.log(areaID);
        setSelect(event.value["AreaID"]);
    }

    useEffect(()=>{
        setChoice(select);
    },[select])

    useEffect(()=>{
        getSpeakers();
    },[])

    return(
            <DropDownList fillMode='solid' textField='AreaName' dataItemKey='AreaID' data={speakers} onChange={selectionChange}/>
    )
}


export const SpeakerReservation =()=>{
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const key = urlParams.get("key");
    const test = urlParams.get("test");
    const [area,setArea]=useState("NJ26-FC");
    const [showScanner,setShowScanner]=useState(true);
    const [scanValue,setScanValue]=useState("124257791");    
    const [hasBlocks,setHasBlocks]=useState(true);
    const [resOpen, setResOpen]=useState(false);
    const [resExists,setResExists]=useState(false);
    const [maxRides,setMaxRides]=useState(false);
    const [isYouth,setIsYouth]=useState(false);
    const [tomorrow,setTomorrow]=useState(undefined);
    const [participant, setParticipant]=useState(undefined);
    const [showChoices, setShowChoices]=useState(false);
    const [resBlocks, setResBlocks]=useState([]);
    //hardcoded for testing  remove the fixed date for production
    const [choice1,setChoice1]=useState("");
    const [choice2,setChoice2]=useState("");
    const [choice3,setChoice3]=useState("");
    const [manEntry, setManEntry]=useState("");
    const [manConfirm,setManConfirm]=useState(false);
    const [showManual,setShowManual]=useState(false);
    const [manParticipant,setManParticipant]=useState(undefined);
    const currTime =new Date().getHours();

    const getTomorrow=()=>{
        let tmrow = new Date("2026-07-26");
        setTomorrow(tmrow);
    }

    const openScanner=()=>{
        setScanValue("");
    }
    const hideScanner=()=>{
        setShowScanner(false);
    }

    const openChoices=()=>{
        setShowChoices(true);
    }

    const hideChoices=()=>{
        setShowChoices(false);
    }

    const saveChoice1=(choice)=>{
        console.log(choice);
        setChoice1(choice);
    }

    const saveChoice2=(choice)=>{
        console.log(choice);
        setChoice2(choice);
    }

    const saveChoice3=(choice)=>{
        console.log(choice);
        setChoice3(choice);
    }

    const openManual=()=>{
        console.log("Open Manual");
        clearParticipant();
        setShowManual(true);
    }

    const closeManual=()=>{
        setShowManual(false);
    }

    const clearParticipant=()=>{
        setManParticipant(undefined);
    }


    const ManualEntry=()=>{
        const manualIDChange=(event)=>{
            console.log(event.value);
            setManEntry(event.value);
        }
        const checkManParticipant = async ()=>{
            if (manEntry!=""){
                const params=new URLSearchParams({id:manEntry, name:""});
                const url= "api/index.php/program/getParticipant?" + params;
                fetch (url,{
                    method:"GET"
                }).then(response=>response.json()).then(async data=> {
                    console.log(data);
                    setManParticipant(data);
                })
            }
        }
        
        const saveManual=()=>{
            setScanValue(manParticipant[0].MemberId)
            closeManual();
            hideScanner();
            setManEntry("");
        }

        return(
            <Dialog className='atol-dlg-error' title={"Enter manual ID"} onClose={closeManual}>
                <p>Enter the ID number found on your Jamboree ID</p>
                <Input onChange={manualIDChange} value={manEntry}></Input>
                {manParticipant?    
                <>
                <p>Are you {manParticipant[0].NameFirst} {manParticipant[0].NameLast}?</p>
                <Button onClick={saveManual}>Yes</Button>
                <Button onClick={clearParticipant}>No</Button>    
                </>
                :null}
                <DialogActionsBar>
                    {manConfirm?
                        <Button>Save</Button>                
                    :
                        <Button onClick={checkManParticipant}>Check ID</Button>
                    }

                </DialogActionsBar>
            </Dialog>
        )
    }


    const saveChoices=()=>{
        console.log(choice1);
        console.log(choice2);
        console.log(choice3);
        const postData = new FormData();
        const url= "api/index.php/program/insertSpeakerReservation";
        postData.append("id",scanValue);
        postData.append("areaId",choice1);
        postData.append("rank",1);
        fetch (url,{
            method:"POST",
            body:postData
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            if (data==0){
                setResExists(true);
            }
        })
        const postData2 = new FormData();
        const url2= "api/index.php/program/insertSpeakerReservation";
        postData2.append("id",scanValue);
        postData2.append("areaId",choice2);
        postData2.append("rank",2);
        fetch (url2,{
            method:"POST",
            body:postData2
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            if (data==0){
                setResExists(true);
            }
        })
        const postData3 = new FormData();
        const url3= "api/index.php/program/insertSpeakerReservation";
        postData3.append("id",scanValue);
        postData3.append("areaId",choice3);
        postData3.append("rank",3);
        fetch (url2,{
            method:"POST",
            body:postData3
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            if (data==0){
                setResExists(true);
            }
        })
        hideChoices();
    }

    const getParticipant = async ()=>{
        const params=new URLSearchParams({id:scanValue, name:""});
        const url= "api/index.php/program/getParticipant?" + params;
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            setParticipant(data);
        })
    }

   const onScan=(err,result)=>{
        if (result){
            console.log(result);
            setScanValue(result.text);
            hideScanner();
        }
    }
     useEffect(()=>{
        if (showScanner){
            setIsYouth(false);
            setResExists(false);
        }
    },[showScanner])
    
    useEffect(()=>{
        if (isYouth){
            openChoices();
        }
    },[isYouth])

    useEffect(()=>{
        if (participant!=undefined){
            const age = participant[0].EventAge;
            const variant =participant[0].Variant;
            let youth = false;
            if (age==="Under 14"||age==="14-17"){
                //if age is under 18
                if (!variant.includes("Staff")){
                    //exclude youth staff
                    youth = true;
                }
            }else{
                //age is over 18
                if (age==="18-26"){
                    if (variant==="Scouts BSA - Male Youth"||variant==="Venturing - Youth (All Genders)"||variant==="Sea Scouts - Youth (All Genders)" || variant==="Scouts BSA - Combined Youth"|| variant==="Scouts BSA - Female Youth"){
                        //youth program participants
                        youth=true;
                    }
                }
            }
            setIsYouth(youth);
        }
    },[participant])

    useEffect(()=>{
        console.log(scanValue);
        if (scanValue===""){
            setShowScanner(true);
        }else{
            //checkEligible()
            getParticipant();
        }
    },[scanValue])

    useEffect(()=>{
        //check available reservation blocks for tomorrow
        console.log(area);
        if (area!=undefined){
            if (area.AreaID!==""){
                if (area.Status!="CLOSED"){
                    console.log("Area is not closed");
                    if (test){
                        setResOpen(true);
                    }else{
                        const now = new Date();
                        const month = now.getMonth();
                        const date = now.getDate();

                        // if (month===6 && date<24){ 
                        //     if (date===23){
                        //         if (currTime<13){
                        //             setResOpen(true);
                        //         }
                        //     }else{
                                setResOpen(true);
                        //     }
                        // }
                    }
                    getTomorrow();
                }else{
                    console.log("Area is closed");
                }
            }
        }
    },[area])

    useEffect(()=>{
        console.log("Res Open");
        console.log(resOpen);
    },[resOpen])

    return(
        // area!=undefined?
            <div className="App">
            <AreaTitle area={"Community Leader Fireside Chats"}></AreaTitle>
            {resOpen?
                //Reservations are open and slots are availabe.
                <>
                {hasBlocks?
                    <>
                    {showScanner?
                        <>
                         {showManual?
                            <ManualEntry></ManualEntry>
                        :null}
                        <div style={{fontSize:"xxx-Large", textAlign:"center"}}><FontAwesomeIcon icon={faCamera} /></div>
                        <h3>Request a reservation</h3>
                        <p>Scan the barcode on your Jamboree ID<br/>to request a reservation for:</p>
                        <h4>Community Leader Fireside Chats</h4>
                        <p>during the<br/>Americana Extravaganza</p>
                        <h4>Sunday July 26, 2026</h4>
                        <Button onClick={openManual}>Having trouble reading the barcode?</Button>
                        <BarcodeScanner onUpdate={onScan}></BarcodeScanner>
                        </>
                    :
                    
                        //display scan results
                        <>
                        {isYouth===false?
                            //No adults allowed
                            <div className={"scanResult stop"}>
                                <div style={{fontSize:"xxx-Large"}}><FontAwesomeIcon icon={faFaceFrown} /></div>
                                <h1>Youth Only</h1>
                                <p>Sorry. Reservations are reserverved for youth participants only.</p>
                                <p>{scanValue}</p>
                                <Button size='large' fillMode='outline' style={{color:"white", width:"95%"}} onClick={openScanner}>Scan Another ID</Button>
                            </div>                        
                        :
                            resExists?
                                //reservation already exists
                                <>
                                    <div className={"scanResult go"}>
                                        <div style={{fontSize:"xxx-Large"}}><FontAwesomeIcon icon={faFaceSmile} /></div>
                                        <h1>Existing Request</h1>
                                        <h3>A reservation request has<br/>already been submitted for:</h3>
                                        <p>{scanValue}</p>
                                        <p>Scan your id barcode again after 6:00 PM to see if your request has been selected and to verify your designated time and location.</p>
                                        <Button size='large' fillMode='outline' style={{color:"white", width:"95%"}} onClick={openScanner}>Scan Another ID</Button>
                                    </div>
                                </>
                            :
                                showChoices?
                                <div>
                                    <h1>Select Your Speakers</h1>
                                    <p>for Participant ID: {scanValue}</p>
                                    {openChoices?
                                    <>
                                        <p>Select your top 3 speaker choices</p>
                                        <div className='choiceBlock'>
                                            <Label className='choiceLabel'>First Choice:</Label>
                                            <SpeakerList setChoice={saveChoice1}></SpeakerList>
                                        </div>
                                        <div className='choiceBlock'>
                                            <Label  className='choiceLabel'>Second Choice:</Label>
                                            <SpeakerList setChoice={saveChoice2}></SpeakerList>
                                        </div>
                                        <div className='choiceBlock'>
                                            <Label  className='choiceLabel'>Third Choice:</Label>
                                            <SpeakerList setChoice={saveChoice3}></SpeakerList>
                                         </div>
                                       <div>
                                            <Button size='large' fillMode='solid' themeColor='primary' style={{width:"90%"}} onClick={saveChoices}>SAVE</Button>
                                       </div>
                                    </>
                                    :
                                       <></> 
                                    }
                                    {/* <p>Scan your id barcode again after 6:00 PM to to see if your request has been selected and to verify your designated check-in time and location.</p>
                                    <Button size='large' fillMode='outline' style={{color:"white", width:"95%"}} onClick={openScanner}>Scan Again</Button> */}
                                </div>
                                :
                                <div className={"scanResult go"}>
                                    <div style={{fontSize:"xxx-Large"}}><FontAwesomeIcon icon={faFaceSmile} /></div>
                                    <h1>Reservation<br/>request saved for:</h1>
                                    <p>{scanValue}</p>
                                    <p>{tomorrow.toDateString()}</p>
                                    <p>Scan your id barcode again after 6:00 PM to to see if your request has been selected and to verify your designated check-in time and location.</p>
                                    <Button size='large' fillMode='outline' style={{color:"white", width:"95%"}} onClick={openScanner}>Scan Again</Button>
                                </div>
                            }
                            </> 
                        }
                    </>
                :
                //No reservations slots configured for the selected date
                    <div className={"scanResult stop"}>
                        <div style={{fontSize:"xxx-Large"}}><FontAwesomeIcon icon={faFaceFrown} /></div>
                        <h1>No Spaces Available</h1>
                        <p>for</p>
                        <p>{tomorrow.toDateString()}</p>
                        <p>This area does not have any spaces available for reservations for the specified date.<br/>Reservation requests for the following day are accepted between 8 a.m. and 5 p.m. daily beginning on July 22, 2026</p>
                    </div>  
                }
                </>
            :
                // Reservations closed. Outside the resevervation window of 8 AM - 5 PM                
                <div className={"scanResult stop"}>
                    <div style={{fontSize:"xxx-Large"}}><FontAwesomeIcon icon={faFaceFrown} /></div>
                    <h1>Reservations Closed</h1>
                    <p>for</p>
                    <p>{tomorrow!=undefined?tomorrow.toDateString():area.AreaName}</p>
                    <p>Reservation requests for the following day are accepted between 8 a.m. and 5 p.m. daily beginning on July 22, 2026</p>
                </div>
            }
            </div>
        // :
        //     //Inavid program areas.
        //     <div className={"scanResult stop"}>
        //         <div style={{fontSize:"xxx-Large"}}><FontAwesomeIcon icon={faFaceFrown} /></div>
        //         <h1>Invalid Program Area</h1>
        //         <p>The specified program area was not found.</p>
        //     </div>  
    )
}